import { render, staticRenderFns } from "./BusinessDashboardStorage.vue?vue&type=template&id=37bbc31e&scoped=true&"
import script from "./BusinessDashboardStorage.vue?vue&type=script&lang=js&"
export * from "./BusinessDashboardStorage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDashboardStorage.vue?vue&type=style&index=0&id=37bbc31e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bbc31e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VHover,VIcon,VImg,VSheet})
